import { render, staticRenderFns } from "./ProxyManage.vue?vue&type=template&id=a935ba26&scoped=true&"
import script from "./ProxyManage.vue?vue&type=script&lang=js&"
export * from "./ProxyManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a935ba26",
  null
  
)

export default component.exports